import { LocalStorage } from 'src/services/LocalStorage'

export const hasFlag = (flag) => {
  const currentFlags = LocalStorage.getItem('flags') || ''
  return currentFlags.indexOf(flag) !== -1
}

export default hasFlag
